import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OrderSummaryCart from '../../molecules/OrderSummaryCart';
import './OrderSummary.scss';

const OrderSummary = ({
  className,
  labels,
  data,
  userState,
  collapseIcon,
  openIcon,
  userIcon,
  signInUrl,
  isCheckout,
  isCart,
  children,
  isOrderConfirmation,
  pageContext,
  addPromoCode,
  getpromoCodeDetails,
  promotionIconUrl,
  errorIcon,
  closeIcon,
  showPromotionalCode,
  isQuoteToOrder,
  orderSummaryDataStatus,
  includeTaxWithPrice,
  shareCartIcon,
  isShareCartEnabled,
  handleShareCartButtonClick,
  openShippingOptionModal,
  shippingInfo,
  renderItemSummaryContainer,
  isPromotionDisabled,
  renderTaxExemptCertificate,
}) => {
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  const [stickyClass, setStickyClass] = useState({});

  /* istanbul ignore next */
  React.useEffect(() => {
    if (!orderSummaryDataStatus) {
      const header = document.getElementById('summaryContainer');
      const footer = document.getElementById('cmp-footer');
      const height = header.offsetHeight;
      let style = {
        minHeight: `${height}px`,
      };
      setStickyClass(style);
      if (isIE11 && !isOrderConfirmation) {
        const sticky = header.offsetTop;
        const padding = 8;
        const left = header.offsetLeft - padding;
        const width = header.offsetWidth;
        const scrollCallBack = window.addEventListener('scroll', () => {
          const { clientHeight } = header;
          const topC = (window.scrollY + clientHeight - clientHeight / 2 - footer.offsetTop) * 2;
          if (
            window.scrollY > sticky &&
            window.scrollY + clientHeight - clientHeight / 2 < footer.offsetTop
          ) {
            style = {
              left: `${left}px`,
              position: 'fixed',
              width: `${width + padding * 2}px`,
              top: topC < -clientHeight ? 0 : -(topC + clientHeight),
              minHeight: `${height + 250}px`,
            };
            setStickyClass(style);
          } else {
            setStickyClass({});
          }
        });

        return () => {
          window.removeEventListener('scroll', scrollCallBack);
        };
      }
      return undefined;
    }
    return undefined;
  }, [orderSummaryDataStatus]);

  return (
    <div
      className={`order-summary ${isOrderConfirmation ? 'no-sticky' : ''} ${className}`}
      data-locator="order-summary-section"
      style={stickyClass}
    >
      <div id="summaryContainer">
        <OrderSummaryCart
          data={data}
          labels={labels}
          userState={userState}
          collapseIcon={collapseIcon}
          openIcon={openIcon}
          userIcon={userIcon}
          signInUrl={signInUrl}
          isCheckout={isCheckout}
          isCart={isCart}
          isOrderConfirmation={isOrderConfirmation}
          pageContext={pageContext}
          addPromoCode={addPromoCode}
          getpromoCodeDetails={getpromoCodeDetails}
          promotionIconUrl={promotionIconUrl}
          errorIcon={errorIcon}
          closeIcon={closeIcon}
          showPromotionalCode={showPromotionalCode}
          isQuoteToOrder={isQuoteToOrder}
          includeTaxWithPrice={includeTaxWithPrice}
          shareCartIcon={shareCartIcon}
          isShareCartEnabled={isShareCartEnabled}
          handleShareCartButtonClick={handleShareCartButtonClick}
          openShippingOptionModal={openShippingOptionModal}
          shippingInfo={shippingInfo}
          renderItemSummaryContainer={renderItemSummaryContainer}
          isPromotionDisabled={isPromotionDisabled}
          renderTaxExemptCertificate={renderTaxExemptCertificate}
        />
        {children}
      </div>
    </div>
  );
};
OrderSummary.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  labels: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  data: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array])
  ),
  userState: PropTypes.string.isRequired,
  userIcon: PropTypes.string,
  collapseIcon: PropTypes.string,
  openIcon: PropTypes.string,
  signInUrl: PropTypes.string,
  isCheckout: PropTypes.bool,
  isCart: PropTypes.bool,
  isOrderConfirmation: PropTypes.bool,
  pageContext: PropTypes.string,
  addPromoCode: PropTypes.func,
  getpromoCodeDetails: PropTypes.func,
  promotionIconUrl: PropTypes.string,
  errorIcon: PropTypes.string,
  closeIcon: PropTypes.string,
  showPromotionalCode: PropTypes.bool,
  isQuoteToOrder: PropTypes.bool,
  orderSummaryDataStatus: PropTypes.bool,
  includeTaxWithPrice: PropTypes.bool,
  shareCartIcon: PropTypes.string,
  isShareCartEnabled: PropTypes.bool,
  handleShareCartButtonClick: PropTypes.func,
  openShippingOptionModal: PropTypes.func,
  shippingInfo: PropTypes.arrayOf(PropTypes.string),
  renderItemSummaryContainer: PropTypes.func,
  isPromotionDisabled: PropTypes.bool,
  renderTaxExemptCertificate: PropTypes.node,
};

OrderSummary.defaultProps = {
  className: '',
  children: <div />,
  labels: {},
  data: {},
  userIcon: '',
  collapseIcon: '',
  openIcon: '',
  signInUrl: '',
  isCheckout: false,
  isCart: false,
  isQuoteToOrder: false,
  isOrderConfirmation: false,
  pageContext: '',
  addPromoCode: () => {
    /* default addPromoCode handler */
  },
  getpromoCodeDetails: () => {
    /* default getpromoCodeDetails handler */
  },
  promotionIconUrl: '',
  errorIcon: '',
  closeIcon: '',
  showPromotionalCode: true,
  orderSummaryDataStatus: false,
  includeTaxWithPrice: false,
  shareCartIcon: '',
  isShareCartEnabled: false,
  handleShareCartButtonClick: () => {
    /* default handleShareCartButtonClick handler */
  },
  openShippingOptionModal: () => {
    /* default openShippingOptionModal handler */
  },
  shippingInfo: [],
  renderItemSummaryContainer: () => {
    /* default renderItemSummaryContainer handler */
  },
  isPromotionDisabled: false,
  renderTaxExemptCertificate: <div />,
};

export default OrderSummary;
